import { render, staticRenderFns } from "./TicketsDashboard.vue?vue&type=template&id=8c69b7c4&scoped=true"
import script from "./TicketsDashboard.vue?vue&type=script&lang=js"
export * from "./TicketsDashboard.vue?vue&type=script&lang=js"
import style0 from "./TicketsDashboard.vue?vue&type=style&index=0&id=8c69b7c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c69b7c4",
  null
  
)

export default component.exports